import { useState } from 'react'

import { QA_NAME_UPLOAD_FILE } from '../../../constants/qa'
import { getQaSelector } from '../../../utils/common'
import { setRef } from '../../../utils/react'
import { FILE_UPLOAD_DROPZONE_OPTIONS, useFileDropzone } from '../File.hooks'

import * as styles from './FileUpload.module.css'

function FileUpload({
  children,
  className,
  disabled,
  getFiles,
  openOnClick = true,
  options,
  outboundUuid,
  ref,
  uploadedFilesLength,
  useBase64,
  onClick,
  onCloseModal,
  onDrop,
  onDropRejected,
  onFileDialogCancel,
  onFinishUpload,
  onSetModal,
  onStartUpload,
  onUploadErrors,
}) {
  const [modal, setModal] = useState(null)

  function handleCloseModal() {
    return setModal(null)
  }

  const dropzoneOptions = {
    ...FILE_UPLOAD_DROPZONE_OPTIONS,
    ...options,
    disabled,
    noClick: true,
    noKeyboard: !openOnClick,
  }

  const { getInputProps, getRootProps, open } = useFileDropzone({
    getFiles,
    options: dropzoneOptions,
    outboundUuid,
    uploadedFilesLength,
    useBase64,
    onCloseModal: onCloseModal || handleCloseModal,
    onDrop,
    onDropRejected,
    onFileDialogCancel,
    onFinishUpload,
    onSetModal: onSetModal || setModal,
    onStartUpload,
    onUploadErrors,
  })

  const { ref: dropzoneRootRef, ...rootProps } = getRootProps()

  function handleSetRootRef(node) {
    setRef(dropzoneRootRef, node)

    setRef(ref, node)
  }

  function handleClick() {
    if (!openOnClick || disabled) {
      return
    }

    open()

    onClick?.()
  }

  const qaProps = getQaSelector({ value: QA_NAME_UPLOAD_FILE })

  return (
    <div
      {...rootProps}
      {...qaProps}
      className={className}
      ref={handleSetRootRef}
    >
      {!disabled ? <input {...getInputProps()} /> : null}
      <div className={styles.children} onClick={handleClick}>
        {children}
      </div>
      {modal}
    </div>
  )
}

export default FileUpload
